import { render, staticRenderFns } from "./BankInfoTab2.vue?vue&type=template&id=44c77902&scoped=true"
import script from "./BankInfoTab2.vue?vue&type=script&lang=js"
export * from "./BankInfoTab2.vue?vue&type=script&lang=js"
import style0 from "./BankInfoTab2.vue?vue&type=style&index=0&id=44c77902&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c77902",
  null
  
)

export default component.exports